import React from 'react';
import { GameType } from '../types';
import { TowerGame } from './tower/TowerGame';
import { PuzzleGame } from './puzzle/PuzzleGame';
import { DrawGuessGame } from './draw/DrawGuessGame';

interface GameContainerModalProps {
  game: GameType | null;
  mode?: 'normal' | 'competition';
  onClose: () => void;
  onOpenLeaderboard: (game?: GameType) => void;
}

export const GameContainerModal: React.FC<GameContainerModalProps> = ({
  game,
  mode = 'normal',
  onClose,
  onOpenLeaderboard,
}) => {
  if (!game) return null;

  const titles: Record<GameType, string> = {
    tower: mode === 'competition' ? 'Leo tháp mỹ thuật · Thi tuần' : 'Leo tháp mỹ thuật',
    draw: 'Vẽ và đoán',
    puzzle: 'Ghép tranh',
  };

  return (
    <div className="fixed inset-0 z-50 bg-[#171013] flex flex-col h-[100vh] h-[100dvh] max-h-[100dvh] animate-fade-in overflow-hidden">
      {/* Authentic V2 Header for games other than Tower (Tower manages its own full-screen compact HUD) */}
      {game !== 'tower' && (
        <header className="game-webview__header">
          <button
            onClick={onClose}
            type="button"
            data-close-game
            aria-label="Đóng trò chơi và quay lại landing"
          >
            ← Nhập cuộc
          </button>

          <div>
            <strong id="game-webview-title">{titles[game]}</strong>
            <span>WEB GAME · DỮ LIỆU MẪU</span>
          </div>

          <img
            src="/images/logo/vnfam-logo-horizontal-transparent.webp"
            alt="VNFAM"
            onClick={onClose}
            className="cursor-pointer"
          />
        </header>
      )}

      {/* Main Game Screen with dynamic 100% height and overflow containment */}
      <div className="flex-1 min-h-0 h-full overflow-hidden bg-[#171013]">
        {game === 'tower' && (
          <TowerGame
            mode={mode}
            onClose={onClose}
            onOpenLeaderboard={() => onOpenLeaderboard('tower')}
          />
        )}
        {game === 'draw' && (
          <DrawGuessGame
            onClose={onClose}
            onOpenLeaderboard={() => onOpenLeaderboard('draw')}
          />
        )}
        {game === 'puzzle' && (
          <PuzzleGame
            onClose={onClose}
            onOpenLeaderboard={() => onOpenLeaderboard('puzzle')}
          />
        )}
      </div>
    </div>
  );
};
